import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { LinearTransition } from 'react-native-reanimated';

import { useResponsive } from '@sg/garnish';

import { AddToBag } from '@order/features-customization';

import { TransparentModal } from '../../../../components';
import { useNavigateBack } from '../../../../navigation';
import { QUICK_ADD_LAYOUT_DURATION } from '../../QuickAddScreen.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const QuickAddModal = (props: PropsWithChildren) => {
  const { children } = props;

  const navigateBack = useNavigateBack();
  const { match, currentBreakpoint } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([styles.containerXS, undefined])];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <TransparentModal
      size="medium"
      mobileEdges={MOBILE_EDGES}
      dialogLayout={DIALOG_LAYOUT_TRANSITION}
      onClose={navigateBack}
    >
      {currentBreakpoint.isXS ? <AddToBag.NavigationHeader onBack={navigateBack} /> : null}

      <View style={containerStyles}>{children}</View>
    </TransparentModal>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DIALOG_LAYOUT_TRANSITION = LinearTransition.duration(QUICK_ADD_LAYOUT_DURATION);
const MOBILE_EDGES: ComponentProps<typeof TransparentModal>['mobileEdges'] = [];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    minHeight: 240,
    justifyContent: 'center',
  },
  containerXS: {
    flex: 1,
  },
});
